/* eslint-disable react/jsx-one-expression-per-line */
import { isEmpty, startCase, toLower } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  ClickAwayListener,
  DialogContent,
  FormHelperText,
  Modal,
  Paper,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import styles from './Deliveries.module.css';
import modalStyles from '../ReusableComponents/ReusableComponents.module.css';
import DeliveryDetails from './DeliveryDetails';
import BookingTypes from '../../Lib/Constants/booking-types';
import BlockDetails from './BlockDetails';
import TextInput from '../ReusableComponents/TextInput/TextInput';
import Button from '../ReusableComponents/Button/Button';

const useStyles = makeStyles()((theme) => ({
  confirm: {
    color: 'white',
    background: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
}));

export default function RemoveBookingModal(props) {
  const { classes } = useStyles();
  const { booking, open, onClose, onRemove, locations } = props;
  const { type } = booking;
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const isBlock = type === BookingTypes.BLOCK;

  const onCloseModal = () => {
    setReason('');
    onClose(booking);
  };

  const onRemoveBooking = () => {
    if (!isBlock && isEmpty(reason)) {
      setError('You must enter a cancellation reason');
    } else {
      onRemove(booking, reason);
      setReason('');
      setError('');
    }
  };

  return (
    <Modal open={open} onClose={onCloseModal}>
      <DialogContent className={modalStyles.modalContainer}>
        <ClickAwayListener onClickAway={onCloseModal}>
          <div
            className={modalStyles.modalInner}
            data-testid="remove-booking-modal-inner"
          >
            <Paper className={styles.removeModal}>
              <div className={styles.removeModalPrompt}>
                Are you sure that you would like to remove this
                {` ${startCase(toLower(type))}?`}
              </div>

              {isBlock ? (
                <BlockDetails block={booking} />
              ) : (
                <DeliveryDetails locations={locations} delivery={booking} />
              )}

              {!isBlock && (
                <TextInput
                  error={!isEmpty(error)}
                  fullWidth
                  id="delivery-cancellation-reason"
                  type="text"
                  name="reason"
                  onChange={({ target: { value } }) => {
                    setReason(value);
                  }}
                  value={reason}
                  aria-describedby="delivery-cancellation-reason-helper"
                  label="Cancellation Reason:"
                  formHelperText={
                    <FormHelperText id="delivery-cancellation-reason-helper">
                      {error}
                    </FormHelperText>
                  }
                />
              )}

              <div className={styles.removeModalActions}>
                <Button
                  className={classes.confirm}
                  variant="contained"
                  onClick={onRemoveBooking}
                  color="primary"
                >
                  Confirm
                </Button>
                <Button
                  variant="outlined"
                  onClick={onCloseModal}
                  color="primary"
                >
                  Cancel
                </Button>
              </div>
            </Paper>
          </div>
        </ClickAwayListener>
      </DialogContent>
    </Modal>
  );
}

RemoveBookingModal.propTypes = {
  booking: PropTypes.shape({}).isRequired,
  locations: PropTypes.shape({}).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
